import AdobeLaunch from "@/plugins/adobe-launch";

jest.mock("@/utils", () => ({
  getEnvironment: jest.fn(() => ({
    name: "de",
    description: "Desarrollo",
    adobeLaunch:
      "//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-8bd807155300-development.min.js"
  }))
}));

describe("AdobeLaunch plugin", () => {
  let VueMock;

  beforeEach(() => {
    document.head.innerHTML = "";
    window.isPagePrehiding = false;
    jest.useFakeTimers();
    VueMock = {
      $log: {
        info: jest.fn()
      }
    };
  });

  afterEach(() => {
    jest.runOnlyPendingTimers();
    jest.useRealTimers();
    jest.restoreAllMocks();
  });

  it("should inject Adobe Launch script in document head", () => {
    AdobeLaunch.install(VueMock);

    const script = document.head.querySelector(
      "script[src='//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-8bd807155300-development.min.js']"
    );

    expect(script).not.toBeNull();
    expect(script.async).toBe(true);
    expect(script.defer).toBe(true);
  });

  it("should apply Adobe Target prehiding before injecting Launch", () => {
    AdobeLaunch.install(VueMock);

    const style = document.head.querySelector("#at-body-style");

    expect(window.isPagePrehiding).toBe(true);
    expect(style).not.toBeNull();
    expect(style.innerHTML).toBe("body {opacity: 0 !important}");
  });

  it("should log the injected environment description", () => {
    AdobeLaunch.install(VueMock);

    expect(VueMock.$log.info).toHaveBeenCalledWith(
      "AdobeLaunch inyectada",
      "Desarrollo"
    );
  });

  it("should remove Adobe Target prehiding style after timeout", () => {
    AdobeLaunch.install(VueMock);

    expect(document.head.querySelector("#at-body-style")).not.toBeNull();

    jest.advanceTimersByTime(3000);

    expect(document.head.querySelector("#at-body-style")).toBeNull();
  });

  it("should not duplicate Adobe Target prehiding style when it already exists", () => {
    const existingStyle = document.createElement("style");
    existingStyle.id = "at-body-style";
    existingStyle.innerHTML = "existing prehiding style";
    document.head.appendChild(existingStyle);

    AdobeLaunch.install(VueMock);

    const styles = document.head.querySelectorAll("#at-body-style");

    expect(styles).toHaveLength(1);
    expect(styles[0]).toBe(existingStyle);
    expect(styles[0].innerHTML).toBe("existing prehiding style");
  });

  it("should not add Adobe Target prehiding style when head is not available", () => {
    const getElementsByTagName = jest.spyOn(document, "getElementsByTagName");
    getElementsByTagName.mockImplementationOnce(() => []);

    AdobeLaunch.install(VueMock);

    expect(window.isPagePrehiding).toBe(true);
    expect(document.head.querySelector("#at-body-style")).toBeNull();
  });
});
